/* Joe Luxe mobile menu: adds a "Shop" label, live piece counts, a quieter
   second group (The Index, Contact, Account) and a brand line + Instagram at
   the foot of the theme's drawer. Runs whenever the drawer opens and is
   idempotent, so it survives the header re-rendering. Data comes from
   #jl-menu-data (layout/theme.liquid), so counts stay live as products grow. */
(function () {
  var el = document.getElementById('jl-menu-data');
  if (!el) return;
  var data;
  try { data = JSON.parse(el.textContent); } catch (e) { return; }
  var counts = data.counts || {};

  function note(a, text) {
    if (a.querySelector('.jl-menu-count')) return;
    var i = document.createElement('i');
    i.className = 'jl-menu-count';
    i.textContent = text;
    a.appendChild(i);
  }

  function enhance() {
    var drawer = document.querySelector('header-drawer .menu-drawer');
    if (!drawer || drawer.hasAttribute('data-jl-menu')) return;
    var list = drawer.querySelector('.menu-drawer__menu');
    if (!list) return;
    drawer.setAttribute('data-jl-menu', '');

    var small = document.createElement('ul');
    small.className = 'jl-menu-small list-unstyled';
    small.setAttribute('role', 'list');

    Array.prototype.slice.call(list.children).forEach(function (li) {
      var a = li.querySelector('a.menu-drawer__menu-item');
      if (!a) return;
      var path = (a.getAttribute('href') || '').replace(window.location.origin, '').split('?')[0];
      var isIndex = path.indexOf('/collections/the-index') === 0;
      if (isIndex || !(path in counts)) {
        small.appendChild(li);
        if (isIndex) note(a, 'All pieces');
      } else {
        note(a, String(counts[path]));
      }
    });

    if (data.account) {
      var li = document.createElement('li');
      li.innerHTML = '<a class="menu-drawer__menu-item jl-menu-small__link" href="' + data.account + '"><span class="menu-drawer__menu-item-text">Account</span></a>';
      small.appendChild(li);
    }

    var kicker = document.createElement('p');
    kicker.className = 'jl-menu-kicker';
    kicker.textContent = 'Shop';
    list.parentNode.insertBefore(kicker, list);
    if (small.children.length) list.parentNode.insertBefore(small, list.nextSibling);

    var foot = document.createElement('div');
    foot.className = 'jl-menu-foot';
    var p = document.createElement('p');
    p.textContent = data.line || '';
    foot.appendChild(p);
    if (data.ig) {
      var ig = document.createElement('a');
      ig.href = data.ig;
      ig.target = '_blank';
      ig.rel = 'noopener';
      ig.innerHTML = 'Instagram&nbsp;&#8599;';
      foot.appendChild(ig);
    }
    drawer.appendChild(foot);
  }

  /* Before the drawer opens (tap on ☰) and on its toggle, in case it re-rendered */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('header-drawer summary')) enhance();
  }, true);
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.id === 'Details-menu-drawer-container') enhance();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
})();
